// =========================================================
// SCROLL — Lenis SUPPRIMÉ (demande Olivier 14/07) : le smooth des ancres est
// assuré par le CSS natif `html { scroll-behavior: smooth }` (posé dans
// _theme-hero, avec exception prefers-reduced-motion). ScrollTrigger écoute
// le scroll natif, plus besoin de synchronisation.
// Reste ici : le recalage de ScrollTrigger quand la page change de hauteur
// après coup (accordéon FAQ ouvert, confirmation GF ajax…) — sinon les
// triggers situés plus bas gardent des positions obsolètes.
// =========================================================
import { ScrollTrigger } from 'gsap/ScrollTrigger';

document.addEventListener('DOMContentLoaded', () => {

    // ⚠️ ScrollTrigger.refresh() REPOSE la position de scroll → il TUE une
    // animation de scroll native en cours (clic d'ancre du sommaire interrompu
    // à mi-course quand une image lazy chargeait pendant le trajet, vécu).
    // → on n'appelle refresh que quand le scroll est CALME depuis 200 ms.
    let lastScrollAt = 0;
    window.addEventListener('scroll', () => {
        lastScrollAt = performance.now();
    }, {passive: true});

    let pending = null;
    const refreshWhenIdle = () => {
        if (pending) clearTimeout(pending);
        const tick = () => {
            if (performance.now() - lastScrollAt < 200) {
                pending = setTimeout(tick, 200);
                return;
            }
            pending = null;
            ScrollTrigger.refresh();
        };
        pending = setTimeout(tick, 50);
    };

    if ('ResizeObserver' in window) {
        let lastHeight = document.body.offsetHeight;
        new ResizeObserver(() => {
            if (document.body.offsetHeight === lastHeight) return;
            lastHeight = document.body.offsetHeight;
            refreshWhenIdle();
        }).observe(document.body);
    }
});
